import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["cannotPublishOnDomainReason", "errors", "warnings", "canSchedule", "publishEnabled", "unpublishEnabled", "testVariationTooltipPropsForApproval", "extraDropdownActions", "buttonTextKey", "updateFocusedItemAction", "tooltipOverride", "isLocked", "onClickLocked", "shouldConfirmPublishAction", "shouldUseCustomPublishHandler", "customPublishHandler", "publish", "unpublish"],
  _excluded2 = ["publishDropdownActions", "approvalDropdownActions", "isPublishEnabled", "isPublishInProgress", "loadingFailed", "publishErrors", "publishWarnings", "errorsAndWarningsCount", "onIssueClick", "handleMouseEnterButton", "handleTrackOnDropdownCompleteAction", "openModal", "closeModal"];
import EPIssueButton from 'editor-components/header/EPIssueButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EditorApprovalButtons from '../approvals/EditorApprovalButtons';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUnifiedPublishType
// @ts-expect-error Untyped module
} from '../../redux/selectors/publishSelectors';
import UILockBadge from 'UIComponents/badge/UILockBadge';
// @ts-expect-error Untyped module
import { updatePublishImmediately } from '../../redux/actions/publishActions';
import { PublishTypes } from '../../constants/PublishTypes';
import { PublishActionModalNames } from '../publishing/types/publishButtonTypes';
import useEditorPublishProps from '../publishing/hooks/useEditorPublishProps';
import EditorPublishButtonActionModals from '../publishing/modals/EditorPublishButtonActionModals';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditorPublishButton = _ref => {
  let {
      cannotPublishOnDomainReason,
      errors,
      warnings,
      canSchedule,
      publishEnabled,
      unpublishEnabled,
      testVariationTooltipPropsForApproval = {
        isTestVariation: false,
        testVariationDisabledTooltip: undefined
      },
      extraDropdownActions,
      buttonTextKey,
      updateFocusedItemAction,
      tooltipOverride,
      isLocked = false,
      onClickLocked = () => {},
      shouldConfirmPublishAction,
      shouldUseCustomPublishHandler,
      customPublishHandler,
      publish,
      unpublish
    } = _ref,
    publishModalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _useEditorPublishProp = useEditorPublishProps({
      canSchedule,
      cannotPublishOnDomainReason,
      isLocked,
      extraDropdownActions,
      unpublishEnabled,
      publishEnabled,
      errors,
      warnings,
      updateFocusedItemAction
    }),
    {
      publishDropdownActions,
      approvalDropdownActions,
      isPublishEnabled,
      isPublishInProgress,
      loadingFailed,
      publishErrors,
      publishWarnings,
      errorsAndWarningsCount,
      onIssueClick,
      handleMouseEnterButton,
      handleTrackOnDropdownCompleteAction,
      openModal,
      closeModal
    } = _useEditorPublishProp,
    publishActionModalProps = _objectWithoutPropertiesLoose(_useEditorPublishProp, _excluded2);
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  const dispatch = useDispatch();
  const handlePublishButtonClick = useCallback(() => {
    if (isLocked) {
      onClickLocked();
      return;
    }
    if (shouldUseCustomPublishHandler && customPublishHandler) {
      customPublishHandler();
      return;
    }
    if (unifiedPublishType !== PublishTypes.schedule) {
      dispatch(updatePublishImmediately(true));
    }
    if (shouldConfirmPublishAction) {
      openModal(PublishActionModalNames.PUBLISH_CONFIRM);
      return;
    }
    publish();
  }, [customPublishHandler, dispatch, isLocked, onClickLocked, openModal, publish, shouldConfirmPublishAction, shouldUseCustomPublishHandler, unifiedPublishType]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditorApprovalButtons, Object.assign({
      errorsAndWarningsCount: errorsAndWarningsCount,
      onOpenWarningsAndSuggestionsPanel: () => openModal(PublishActionModalNames.WARNINGS_AND_SUGGESTIONS),
      buttonSize: "sm",
      dropdownProps: {
        buttonSize: 'sm'
      },
      extraActionButtons: approvalDropdownActions
    }, testVariationTooltipPropsForApproval, {
      children: /*#__PURE__*/_jsx("div", {
        "data-onboarding": "onboarding-publish-button",
        "data-campaign-assistant-onboarding-tour": "tour-step-publish",
        children: /*#__PURE__*/_jsxs(EPIssueButton, {
          actions: publishDropdownActions,
          "data-test": "publish-issue-button",
          errors: publishErrors,
          warnings: publishWarnings,
          tooltipOverride: tooltipOverride,
          onButtonClick: handlePublishButtonClick,
          onDropdownOpenComplete: handleTrackOnDropdownCompleteAction,
          onIssueClick: onIssueClick,
          onMouseEnter: handleMouseEnterButton,
          disabled: !isPublishEnabled,
          loading: isPublishInProgress,
          loadingFailed: loadingFailed,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonTextKey
          }), isLocked ? /*#__PURE__*/_jsx(UILockBadge, {}) : null]
        })
      })
    })), /*#__PURE__*/_jsx(EditorPublishButtonActionModals, Object.assign({
      publishErrors: publishErrors,
      publishWarnings: publishWarnings,
      buttonTextKey: buttonTextKey,
      onIssueClick: onIssueClick,
      publish: publish,
      unpublish: unpublish,
      openModal: openModal,
      closeModal: closeModal
    }, publishModalProps, publishActionModalProps))]
  });
};
export default EditorPublishButton;